// Saldo do limite de compra parcelada da unidade (mensal ou por período) frente ao carrinho atual.
// À vista não tem limite. Considera só produtos (com descontos), sem frete e seguro — mesma regra do backend.
import moment from 'moment'
import { t } from 'ab18n'

const API_DATE = 'YYYY-MM-DD'

const isSet = value => value !== null && value !== undefined
const round = value => Math.round(value * 100) / 100

// opção de pagamento à vista (1x), mesmo valor de PurchaseLimitService::CASH_INSTALLMENT
export const CASH_INSTALLMENT = 1

export const isInstallment = monthlyInstallment => (
  isSet(monthlyInstallment) && Number(monthlyInstallment) !== CASH_INSTALLMENT
)

export const cartProductsValue = (cart, discount = 0) => round(
  cart.reduce((total, kit) => total + kit.price * kit.quantity, 0) - (discount || 0)
)

// null quando a unidade não tem limite ou quando o período dela não está valendo agora
const getPurchaseLimitStatus = (cart, cartProperties) => {
  if (!cartProperties || !isSet(cartProperties.purchaseLimit)) return null
  if (cartProperties.purchaseLimitActive === false) return null

  const {
    purchaseLimit,
    purchaseLimitType,
    purchaseLimitPeriodStart,
    purchaseLimitPeriodEnd,
    purchaseLimitUsed,
    purchaseLimitAvailable,
    discount,
  } = cartProperties

  const balance = isSet(purchaseLimitAvailable) ? purchaseLimitAvailable : purchaseLimit
  const cartValue = cartProductsValue(cart || [], discount)
  const available = round(balance - cartValue)

  return {
    limit: purchaseLimit,
    // datas do período (AAAA-MM-DD); sem início = limite mensal; sem fim = período aberto
    periodStart: purchaseLimitType === 'period' ? purchaseLimitPeriodStart || null : null,
    periodEnd: purchaseLimitType === 'period' ? purchaseLimitPeriodEnd || null : null,
    // pedidos parcelados já feitos no mês corrente ou no período
    used: purchaseLimitUsed || 0,
    balance,
    cartValue,
    available,
    // o carrinho não cabe no saldo do limite: só pode ser pago à vista
    exceeded: available < 0,
  }
}

// "neste mês", "de 01/09/2026 a 30/09/2026" ou "a partir de 01/09/2026"
export const formatRange = ({ periodStart, periodEnd }) => {
  if (!periodStart) return t('store.purchaseLimit.range.month')
  const from = moment(periodStart, API_DATE).format('L')
  return periodEnd
    ? t('store.purchaseLimit.range.period', { from, to: moment(periodEnd, API_DATE).format('L') })
    : t('store.purchaseLimit.range.since', { from })
}

export default getPurchaseLimitStatus
